import { ShopGroupDetailsPage } from 'features/shop-groups';

export const TechOperatorShopGroupDetailsPage: React.FC = () => (
  <ShopGroupDetailsPage />
);
